import classNames from 'classnames';
import React from 'react';
import styles from './text-link.module.sass';
import { PolymorphicComponent } from '../../types/polymorphism';

export enum TextLinkType {
  INLINE = 'inline',
  STANDALONE = 'standalone',
}

export enum TextLinkSize {
  SMALL = 'small',
  LARGE = 'large',
}
export type TextLinkProps = {
  type?: TextLinkType;
  size?: TextLinkSize;
};

export const TextLink: PolymorphicComponent<'a', TextLinkProps> = React.memo(
  ({ as: Component = 'a', type = TextLinkType.INLINE, size, className, children, ...props }) => {
    const componentClassName = classNames(className, styles.textLink, {
      [styles.standalone]: type === TextLinkType.STANDALONE,
      [styles.small]: size === TextLinkSize.SMALL,
      [styles.large]: size === TextLinkSize.LARGE,
    });
    return (
      <Component className={componentClassName} {...props}>
        {children}
      </Component>
    );
  },
);

TextLink.displayName = 'textLink';
